export const getInitialState = (): any => ({
  modelViewData: {},
  modelViewStatus: 0
});
